import type { SimpleTableColumn } from "../../../../components/common/simple-table";
import type { UserProductRequestsDto } from "../../../../api";
import { ProductRequestDtoStatusEnum } from "../../../../api";
import { Text } from "../../../../components/common/typography";
import { Button } from "../../../../components/common/button";

function countByStatus(row: UserProductRequestsDto, status: ProductRequestDtoStatusEnum) {
  return row.productRequests?.filter((r) => r.status === status).length ?? 0;
}

function uniqueTypes(row: UserProductRequestsDto): string {
  const types = [...new Set(row.productRequests?.map((r) => r.productType))];
  return types.map((t) => (t === "consu" ? "Consumable" : t)).join(", ") || "—";
}

export function buildAdminProductReviewColumns(
  onView: (userId: string) => void,
): SimpleTableColumn<UserProductRequestsDto>[] {
  return [
    {
      key: "supplier",
      label: "Supplier Name",
      className: "flex-[2] min-w-0",
      render: (row) => (
        <Text variant="bodyBold" tone="dark">{row.userName || "—"}</Text>
      ),
    },
    {
      key: "total",
      label: "Total Products",
      className: "flex-1",
      render: (row) => <Text variant="body" tone="body">{row.productRequests?.length ?? 0}</Text>,
    },
    {
      key: "pending",
      label: "Pending",
      className: "flex-1",
      render: (row) => (
        <Text variant="body" tone="body">{countByStatus(row, ProductRequestDtoStatusEnum.Pending)}</Text>
      ),
    },
    {
      key: "approved",
      label: "Approved",
      className: "flex-1",
      render: (row) => (
        <Text variant="body" tone="body">{countByStatus(row, ProductRequestDtoStatusEnum.Approved)}</Text>
      ),
    },
    {
      key: "rejected",
      label: "Rejected",
      className: "flex-1",
      render: (row) => (
        <Text variant="body" tone="body">{countByStatus(row, ProductRequestDtoStatusEnum.Rejected)}</Text>
      ),
    },
    {
      key: "type",
      label: "Type",
      className: "flex-1",
      render: (row) => <Text variant="body" tone="body">{uniqueTypes(row)}</Text>,
    },
    {
      key: "actions",
      label: "Actions",
      className: "flex-1 flex justify-end",
      render: (row) => (
        <Button
          variant="underlinedGhost"
          size="sm"
          className="!px-0"
          onClick={(e) => { e.stopPropagation(); onView(row.userId); }}
        >
          View
        </Button>
      ),
    },
  ];
}
